import React, { useEffect, useState } from "react";
import { Card, Typography, Space, DatePicker, Row, Col } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs"; // Import dayjs
import "./DashboardPainEnergyMoodHeatmap.css";
import PainLevel1 from "../graphics/painLevels/1.svg";
import PainLevel2 from "../graphics/painLevels/2.svg";
import PainLevel3 from "../graphics/painLevels/3.svg";
import PainLevel4 from "../graphics/painLevels/4.svg";
import PainLevel5 from "../graphics/painLevels/5.svg";
import PainLevel6 from "../graphics/painLevels/6.svg";
import PainLevel7 from "../graphics/painLevels/7.svg";
import PainLevel8 from "../graphics/painLevels/8.svg";
import PainLevel9 from "../graphics/painLevels/9.svg";
import PainLevel10 from "../graphics/painLevels/10.svg";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { useSelector } from "react-redux";

import MoodLevel1 from "../graphics/moodLevels/1.svg";
import MoodLevel2 from "../graphics/moodLevels/2.svg";
import MoodLevel3 from "../graphics/moodLevels/3.svg";
import MoodLevel4 from "../graphics/moodLevels/4.svg";
import MoodLevel5 from "../graphics/moodLevels/5.svg";

import EnergyLevel1 from "../graphics/energyLevels/1.svg";
import EnergyLevel2 from "../graphics/energyLevels/2.svg";
import EnergyLevel3 from "../graphics/energyLevels/3.svg";
import EnergyLevel4 from "../graphics/energyLevels/4.svg";
import EnergyLevel5 from "../graphics/energyLevels/5.svg";

import { getUserPainEnergyMoodHeatMap } from "../redux-toolkit/slices/dashboardSlice";

const { Title } = Typography;
const { MonthPicker } = DatePicker;

const DashboardPainEnergyMoodHeatmap: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = useState<string>(
    dayjs().format("YYYY-MM-DD")
  );

  const dispatch = useAppDispatch();
  const { isError, painEnergyHeatMap, isHeatMapLoading } = useSelector(
    (state: RootState) => state.dashboard
  );
  useEffect(() => {
    dispatch(getUserPainEnergyMoodHeatMap(selectedMonth));
  }, []);
  const handleMonthChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      dispatch(getUserPainEnergyMoodHeatMap(date.format("YYYY-MM-DD")));
      setSelectedMonth(date.format("YYYY-MM-DD")); // Set the selected month
    }
  };

  const days = Array.from(
    { length: painEnergyHeatMap.length },
    (_, i) => i + 1
  );

  const painLevels = painEnergyHeatMap.map((item) => item.averagePainRating);
  const energyLevels = painEnergyHeatMap.map((item) => item.averageEnergyLevel);

  const moodLevels = painEnergyHeatMap.map((item) => item.averageMoodLevel);

  const levelIcons: any = {
    1: PainLevel1,
    2: PainLevel2,
    3: PainLevel3,
    4: PainLevel4,
    5: PainLevel5,
    6: PainLevel6,
    7: PainLevel7,
    8: PainLevel8,
    9: PainLevel9,
    10: PainLevel10,
  };

  const moodLevelIcons: any = {
    1: MoodLevel1,
    2: MoodLevel2,
    3: MoodLevel3,
    4: MoodLevel4,
    5: MoodLevel5,
  };
  const energyLevelIcons: any = {
    1: EnergyLevel1,
    2: EnergyLevel2,
    3: EnergyLevel3,
    4: EnergyLevel4,
    5: EnergyLevel5,
  };
  const getIcon = (type: string, level: number) => {
    if (type === "moodLevels") {
      return moodLevelIcons[level];
    }
    if (type === "painLevels") {
      return levelIcons[level];
    }
    if (type === "energyLevels") {
      return energyLevelIcons[level];
    }
  };
  const renderCells = (levels: (number | null)[], type: string) => {
    return levels.map((level, index) => (
      <div key={index} className="grid-cell">
        {level ? (
          <img
            src={getIcon(type, level)}
            alt={`Level ${level}`}
            className="icon"
          />
        ) : (
          "---"
        )}
      </div>
    ));
  };
  const desktopView = () => {
    return (
      <Row>
        <Col style={{ display: "flex", gap: "20px" }} span={24}>
          <div className="grid-label" style={{ width: "50px" }}>
            Pain
          </div>
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "flex-start" }}
              span={24}
            >
              {renderCells(painLevels, "painLevels")}
            </Col>
          </Row>
        </Col>

        <Col
          style={{ display: "flex", gap: "20px", marginTop: "20px" }}
          span={24}
        >
          <div className="grid-label" style={{ width: "50px" }}>
            Energy
          </div>
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "flex-start" }}
              span={24}
            >
              {renderCells(energyLevels, "energyLevels")}
            </Col>
          </Row>
        </Col>

        <Col
          style={{ display: "flex", gap: "20px", marginTop: "20px" }}
          span={24}
        >
          <div className="grid-label" style={{ width: "50px" }}>
            Mood
          </div>
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "flex-start" }}
              span={24}
            >
              {renderCells(moodLevels, "moodLevels")}
            </Col>
          </Row>
        </Col>

        <Col style={{ display: "flex", gap: "20px" }} span={24}>
          <div className="grid-label" style={{ width: "50px" }}>
            Days
          </div>
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "flex-start" }}
              span={24}
            >
              {days.map((day) => (
                <div key={day} className="grid-cell">
                  {day}
                </div>
              ))}
            </Col>
          </Row>
        </Col>
        {/* <div className="grid-row">
          <div className="grid-label">Energy</div>
          {renderCells(energyLevels)}
        </div>
        <div className="grid-row">
          <div className="grid-label">Mood</div>
          {renderCells(moodLevels)}
        </div> */}
        {/* <div className="grid-row">
          <div className="grid-label">Days</div>
          {days.map((day) => (
            <div key={day} className="grid-cell">
              {day}
            </div>
          ))}
        </div> */}
      </Row>
    );
  };
  const getMobileView = () => {
    return (
      <>
        <Row>
          <Col span={6}>
            <Typography className="grid-label"> Day</Typography>
          </Col>
          <Col span={6}>
            <Typography className="grid-label"> Pain</Typography>
          </Col>
          <Col span={6}>
            <Typography className="grid-label"> Energy</Typography>
          </Col>
          <Col span={6}>
            <Typography className="grid-label"> Mood</Typography>
          </Col>
        </Row>
        <Row style={{ marginBottom: "10px" }}></Row>
        <Row>
          <Col span={6}>
            {days.map((day) => (
              <div key={day} style={{ height: "20px" }} className="grid-cell">
                {day}
              </div>
            ))}
          </Col>
          <Col span={6}>{renderCells(painLevels, "painLevels")}</Col>
          <Col span={6}>{renderCells(energyLevels, "energyLevels")}</Col>
          <Col span={6}>{renderCells(moodLevels, "moodLevels")}</Col>
        </Row>
      </>
    );
  };

  return (
    <Card>
      <div className="heatmap-container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space
            align="center"
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <Title level={3}>Pain, Energy, and Mood Heat Map</Title>
            <MonthPicker
              onChange={handleMonthChange}
              defaultValue={dayjs("2024-09", "YYYY-MM")}
              format="MMMM"
              // picker="month"
              popupClassName="month-picker-dropdown"
              renderExtraFooter={() => null}
              style={{ border: "1px solid #C8C8C8", borderRadius: "4px" }}
            />
          </Space>
          <div className="desktop-view-heat-map">{desktopView()}</div>
          <div className="mobile-view-heat-map">{getMobileView()}</div>
        </Space>
      </div>
    </Card>
  );
};

export default DashboardPainEnergyMoodHeatmap;
